import { SignedIn, SignedOut } from "@clerk/tanstack-react-start";
import { Link, createFileRoute } from "@tanstack/react-router";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useCurrentCompany } from "@/hooks/use-current-account";

export const Route = createFileRoute("/_marketing/")({
  component: HomeComponent,
});

function HomeComponent() {
  const { data: company } = useCurrentCompany();
  const name = company?.name ?? "Afinio";

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="mb-4 text-4xl font-bold">{name}</h1>
        <p className="text-muted-foreground mb-8">Welcome to {name}. Sign in to get started.</p>
        <SignedOut>
          <div className="flex justify-center gap-4">
            <Link to="/sign-in" className={cn(buttonVariants({ variant: "outline" }))}>
              Sign In
            </Link>
            <Link to="/create" className={cn(buttonVariants())}>
              Sign Up
            </Link>
          </div>
        </SignedOut>
        <SignedIn>
          <Link to="/app" className={cn(buttonVariants())}>
            Go to App
          </Link>
        </SignedIn>
      </div>
    </div>
  );
}
